import { render, staticRenderFns } from "./game-list-table.vue?vue&type=template&id=5836088f&"
import script from "./game-list-table.vue?vue&type=script&lang=js&"
export * from "./game-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports